import { createI18n } from 'vue-i18n';
import en from './en.js';
import es from './es.js';

// Supported UI locales. Everything else falls back to English.
const SUPPORTED = ['en', 'es'];

// Normalize a raw locale tag ('es_ES', 'es-MX', 'en_US') to one of SUPPORTED,
// or 'en' when unknown. We only key off the primary subtag (es/en) for now.
function normalizeLocale(raw) {
  if (!raw || typeof raw !== 'string') return 'en';
  const primary = raw.toLowerCase().replace('_', '-').split('-')[0];
  return SUPPORTED.includes(primary) ? primary : 'en';
}

// Resolve the active locale. frontend.php already injects a pre-normalized
// `lang` ('en'|'es', from WP get_locale) alongside the raw `locale` — prefer
// `lang`, fall back to the raw locale, then the browser, then en.
function resolveLocale() {
  const data = window?._EZCL?.data;
  const fromServer = data?.lang || data?.locale;
  const fromBrowser = typeof navigator !== 'undefined' ? navigator.language : '';
  return normalizeLocale(fromServer || fromBrowser || 'en');
}

const i18n = createI18n({
  legacy: false, // Composition API mode (useI18n)
  locale: resolveLocale(),
  fallbackLocale: 'en', // a missing key renders English, never a raw key
  messages: { en, es },
});

// The active UI locale as a BCP-47 tag for Intl / toLocaleDateString. Use this
// ONLY for user-facing DISPLAY formatting — never for values that are compared
// against server data or sent in a payload (those must stay locale-independent:
// ISO strings / numeric weekday keys). 'en'/'es' are valid Intl language tags.
export function localeTag() {
  return i18n.global.locale.value || 'en';
}

export default i18n;
